export default __webpack_public_path__ + "static/media/python.cf32ad96.svg";